import { Inject, Injectable, Injector }from '@angular/core';

import { Ultraship_DatasourceService } from './Ultraship.datasource.index';


@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Ultraship = this.injector.get(Ultraship_DatasourceService);
  }

    public Ultraship: Ultraship_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
}

